/**
 * RippleLoader — indicateur de chargement animé, décliné du monogramme
 * "ripple de clic" du logo (voir Logo.jsx) pour une identité cohérente
 * partout où l'ancien spinner générique (Loader2 + animate-spin) était utilisé.
 *
 * Props:
 *  - size      : taille en px du carré englobant (défaut 40)
 *  - className : classes supplémentaires (ex: positionnement, marges)
 */
const RippleLoader = ({ size = 40, className = "" }) => (
  <span
    role="status"
    aria-label="Chargement…"
    className={`inline-flex items-center justify-center shrink-0 ${className}`}
    style={{ width: size, height: size }}
  >
    <svg viewBox="0 0 64 64" width={size} height={size} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="ripple-loader-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#635BFF" />
          <stop offset="100%" stopColor="#38BDF8" />
        </linearGradient>
      </defs>
      <circle
        cx="32"
        cy="32"
        r="10"
        fill="none"
        stroke="url(#ripple-loader-grad)"
        strokeWidth="4"
        opacity="0.9"
      >
        <animate attributeName="r" values="6;24" dur="1.4s" begin="0s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.9;0" dur="1.4s" begin="0s" repeatCount="indefinite" />
      </circle>
      <circle
        cx="32"
        cy="32"
        r="10"
        fill="none"
        stroke="url(#ripple-loader-grad)"
        strokeWidth="4"
        opacity="0.9"
      >
        <animate attributeName="r" values="6;24" dur="1.4s" begin="0.7s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.9;0" dur="1.4s" begin="0.7s" repeatCount="indefinite" />
      </circle>
      <circle cx="32" cy="32" r="6" fill="url(#ripple-loader-grad)" />
    </svg>
  </span>
);

export default RippleLoader;
